export const TENANT_MAP: Record<string, number> = {
	'landing-page-imatra': 1,
	'landing-page-aic': 2,
};
